import React, { useEffect, useState } from 'react';
import { initialsOf } from './format';

type AvatarSize = 'sm' | 'md' | 'lg' | 'xl';

const SIZE_CLASSES: Record<AvatarSize, string> = {
  sm: 'h-8 w-8 text-xs',
  md: 'h-11 w-11 text-sm',
  lg: 'h-14 w-14 text-base',
  xl: 'h-24 w-24 text-2xl',
};

interface PortalAvatarProps {
  name: string;
  pictureUrl?: string | null;
  size?: AvatarSize;
  /** 'light' for white surfaces, 'dark' for the slate sidebar */
  tone?: 'light' | 'dark';
  className?: string;
}

/** Round photo with an initials fallback (also used when the signed URL has expired). Decorative: the name is always shown beside it. */
const PortalAvatar: React.FC<PortalAvatarProps> = ({ name, pictureUrl, size = 'md', tone = 'light', className = '' }) => {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [pictureUrl]);

  const base = `${SIZE_CLASSES[size]} shrink-0 rounded-full ${className}`;
  if (pictureUrl && !failed) {
    return <img src={pictureUrl} alt="" className={`${base} object-cover ring-2 ring-white/20`} onError={() => setFailed(true)} />;
  }
  const palette = tone === 'dark' ? 'bg-slate-700 text-white' : 'bg-teal-100 text-teal-800';
  return (
    <span aria-hidden="true" className={`${base} inline-flex items-center justify-center font-semibold ${palette}`}>
      {initialsOf(name) || '·'}
    </span>
  );
};

export default PortalAvatar;
